export const messages = {
  en: {
    assistanceMoneyDetail: {
      title: 'Assistance Money Details',
      queryCondition: 'Query Conditions',
      orderId: 'Order ID',
      orderIdPlaceholder: 'Please enter order ID',
      userId: 'User ID',
      userIdPlaceholder: 'Please enter user ID',
      userName: 'User Name',
      userNamePlaceholder: 'Please enter user name',
      tradeType: 'Trade Type',
      tradeTypePlaceholder: 'Please select trade type',
      tradeType1: 'Income',
      tradeType2: 'Expense',
      status: 'Status',
      statusPlaceholder: 'Please select status',
      status0: 'Inactive',
      status1: 'Active',
      query: 'Query',
      detailId: 'Detail ID',
      assistanceMoneyId: 'Assistance Money ID',
      tradeAmount: 'Trade Amount',
      beforeAmount: 'Before Amount',
      afterAmount: 'After Amount',
      tradeFlow: 'Trade Flow',
      tradeDesc: 'Trade Description'
    }
  },
  zh: {
    assistanceMoneyDetail: {
      title: '助力金消费明细',
      queryCondition: '查询条件',
      orderId: '订单ID',
      orderIdPlaceholder: '请输入订单ID',
      userId: '用户ID',
      userIdPlaceholder: '请输入用户ID',
      userName: '用户姓名',
      userNamePlaceholder: '请输入用户姓名',
      tradeType: '交易类型',
      tradeTypePlaceholder: '请选择交易类型',
      tradeType1: '收入',
      tradeType2: '支出',
      status: '状态',
      statusPlaceholder: '请选择状态',
      status1: '禁用',
      status0: '启用',
      query: '查询',
      detailId: '明细ID',
      assistanceMoneyId: '助力金ID',
      tradeAmount: '交易金额',
      beforeAmount: '交易前余额',
      afterAmount: '交易后余额',
      tradeFlow: '交易流水号',
      tradeDesc: '交易描述'
    }
  }
}